
//import {diffDateInMinute,getHistory} from './util'
import Cookies from 'js-cookie'
import { navigate, portalCfg } from '../../portal.router.config'
import { portal_config, connection, custom_assets, domainName } from '../../portal.config';
import { clearSessionOrder } from './order_cache';
import countries from '../../countries';
import t from './translateUtil';
import { createDayOfWeek } from './util';
import { dataUtil, usage_type } from '../wsclient/crmservices/dataUtil';
import crmservices from '../wsclient/crmservices';
var totalCartItem = 0;
export const ACCESS_TOKEN = 'crmcom_access_token';
export const REFRESH_TOKEN = 'crmcom_refresh_token';
const APP_CONFIG = 'app_config';
const CURRENCY = 'currency';
const ORDER_SUPPORT = 'order_support'
const CONTACTS = 'contacts';
const TOPUP_INFO = 'topup_info';
const ADDCARD_INFO = 'addcard_info';
const PAYMENT_RECURING = 'payment_recuring'
//const LANGUAGE = 'LANGUAGE';
var jwtDecode = require('jwt-decode');
var is_logout_call = false;
var _getTotalCartItemHandler = undefined
var _getMyOrderHandler = undefined
var _supportOrderContact = false
var _supportOrderLocation = false
var _is_reject_trigger_contact = false
var _refreshWalletHandler = undefined
export function getSupportOrder() {
    console.log('getSupportOrder====',( _supportOrderContact||_supportOrderLocation))
    return _supportOrderContact||_supportOrderLocation;
}
export function setSupportOrderLocation(status) {
    console.log('setSupportOrderLocation ',status)
    _supportOrderLocation = status;
}
export function getSupportOrderLocation() {
    return _supportOrderLocation;
}
export function setSupportOrderContact(status) {
    console.log('setSupportOrderContact ',status)
    _supportOrderContact = status;
}
export function getSupportOrderContact() {
    return _supportOrderContact;
}
export function setRejectTriggerContact(status){
    console.log('setRejectTriggerContact ',status)
    _is_reject_trigger_contact = status; 
}
export function getRejectTriggerContact(){
    return _is_reject_trigger_contact
}
export function setNotificationListener(callbackFn) {
    //console.log('HHHHHHHHH  setNotificationListener ' + key, callback);
    _getTotalCartItemHandler = callbackFn;
}
export function callCartItemListeners(isAdd) {
    try {
        _getTotalCartItemHandler(isAdd);
    }catch (e) {
        console.log(e);
    }
}
export function setRefreshWalletListener(callbackFn) {
    //console.log('HHHHHHHHH  setNotificationListener ' + key, callback);
    _refreshWalletHandler = callbackFn;
}
export function callRefreshWalletListeners() {
    try {
        _refreshWalletHandler();
    }catch (e) {
        console.log(e);
    }
}
export function setMyOrderListener(callbackFn) {
    _getMyOrderHandler = callbackFn;
}
export function callRefreshMyOrderListeners() {
    try {
        if(_getMyOrderHandler)
            _getMyOrderHandler();
    }catch (e) {
        console.log(e);
    }
}
export async function logOut(isSessionExpire) {
    if (!is_logout_call || !isSessionExpire) {//bị hết hạn lần đầu hoặc logout chủ động
        clearSession();
        navigate('/')
        is_logout_call = true;
    }
    //setSupportOrderContact(false)
    //setSupportOrderLocation(false)
    //setRejectTriggerContact(false)
    // history.push('/');
}
export function getTokenFromCookie(key) {
    let session = key ? Cookies.get(key) : Cookies.get(ACCESS_TOKEN);
    if (session)
        session = JSON.parse(session);
    return session;
}

export function saveDataIntoAsyncStore(key, data) {
    if (key === ACCESS_TOKEN || key === REFRESH_TOKEN) {
        let token = jwtDecode(data)
        let exp = new Date(token.exp *1000);
        //console.log('saveDataIntoAsyncStore token===', token)
        //console.log('saveDataIntoAsyncStore ACCESS_TOKEN===', ACCESS_TOKEN)
        try {
            //console.log('saveDataIntoAsyncStore exp===', exp)
            
            Cookies.set(key, data, { ...connection.crmConfig.cookiesConfig, expires: exp});
        }
         catch(e){
            console.log('saveDataIntoAsyncStore e:', e)
         }   
    } else {
        localStorage.setItem(key, data);
    }
}
export function setAppCfg(data) {
    data = JSON.stringify(data)
    localStorage.setItem(APP_CONFIG, data);
}
export function getAppCfg() {
    var config = localStorage.getItem(APP_CONFIG);
    if (!config)
        return null;
    config = JSON.parse(config);
    return config
}
export function setContacts(data) {
    data = JSON.stringify(data)
    //console.log('setAppCfg== ',data)
    localStorage.setItem(CONTACTS, data);
}
export function getContacts() {
    var config = localStorage.getItem(CONTACTS);
    config = JSON.parse(config)
    //console.log('getContacts== ',config)
    return config
}

export function setCurrency(data) {
    localStorage.setItem(CURRENCY, data);
}
export function getCurrency() {
    var config = localStorage.getItem(CURRENCY);
    if(!config)
        config = '€'
    return config
}

export function setCurrencyCode(data) {
    localStorage.setItem('currency_code', data);
}

export function getCurrencyCode() {
    var config = localStorage.getItem('currency_code');
    return config
}

export function setTopupInfo(value) {
    try{
        value = JSON.stringify(value);

  //  console.log('value1=======',value)
    localStorage.setItem(TOPUP_INFO, value);
    }
    catch(ex){
        console.log("save data to local storage for order exception:",ex);
    }


}
export function getTopupInfo() {

    try{
        var value = localStorage.getItem(TOPUP_INFO);
        if(value){
            value = JSON.parse(value);
        }
        return value;
    }
    catch(ex){
        console.log("get data to local storage for order exception:",ex);
        return null;
    }
}

export function setAddCardInfo(value) {
    try{
        value = JSON.stringify(value);

  //  console.log('value1=======',value)
    localStorage.setItem(ADDCARD_INFO, value);
    }
    catch(ex){
        console.log("save data to local storage for order exception:",ex);
    }


}
export function getAddCardInfo() {

    try{
        var value = localStorage.getItem(ADDCARD_INFO);
        if(value){
            value = JSON.parse(value);
        }
        return value;
    }
    catch(ex){
        console.log("get data to local storage for order exception:",ex);
        return null;
    }
}
export function getData(key) {
    let session = null;
    if (key) {
        if (key === ACCESS_TOKEN || key === REFRESH_TOKEN) {
            session = Cookies.get(key);
        } else {
            session = localStorage.getItem(key);
        }
    } else {
        session = Cookies.get(ACCESS_TOKEN);
    }
    return session;
}

export function clearSession(key) {
    if (key)
        localStorage.removeItem(key);
    else {
        try{
           // console.log('clearSession remove:')
            Cookies.remove(ACCESS_TOKEN, connection.crmConfig.cookiesConfig);
            Cookies.remove(REFRESH_TOKEN, connection.crmConfig.cookiesConfig);
            clearSessionOrder();
        }
        catch(e){
            console.log('clearSession e:', e)
        }
    }

}

export function getLanguage(key) {
    let session = key ? localStorage.getItem(key) : localStorage.getItem(ACCESS_TOKEN);
    return session;
}

export async function fetchCommon(url, options) {
    try {
        var response = await fetch(url, options);
        return response;
    } catch (ex) {
        throw ex;
    }
}


export async function fetchByApikeyCommon(url, options) {
    try {
        var response = await fetch(url, options);
        return response;
    } catch (ex) {
        throw ex;
    }
}

export async function getImageURL(url) {
    if (url) {
        var jwtTokenDecode = await getData(REFRESH_TOKEN);
        if (jwtTokenDecode && jwtTokenDecode.org) {
            url = url + '&orgid=' + jwtTokenDecode.org;
        }
        return url;
    }
    return null;
}
export function getLogo(){
    var logoUrl = "";
    if (portal_config[domainName].localLogo) {
        var path = custom_assets[domainName] && custom_assets[domainName].customImage.logo  ? portalCfg.publicPath + "/custom_assets" : portalCfg.publicPath + "/assets";
        logoUrl = path+ "/images/logo.png"
    } else {
        var app_config = getAppCfg();
        var srcset = ""
        
        if (app_config && app_config.creatives && app_config.creatives.length > 0) {
            var media = app_config.creatives[0].media;
            if (media && media.length > 0) {
                var srcset = ""
                media.forEach((element, index) => {
                    srcset = srcset + element.url + " " + (index + 1) + "x,";
                });
                if (srcset)
                    srcset = srcset.substr(0, srcset.length - 1);
            }
            let business_logo = dataUtil.getImageByUsageTypePortal(app_config.creatives, usage_type.APP_LOGO, true);
            if(business_logo){
                logoUrl = business_logo && business_logo.url ? business_logo.url : null;
            }else{
                var path = custom_assets[domainName] && custom_assets[domainName].customImage.logo  ? portalCfg.publicPath + "/custom_assets" : portalCfg.publicPath + "/assets";
                logoUrl = path+ "/images/logo.png";
            }
        }
    }

    return logoUrl
}
export function getBrowser(){
    let currentBrowser = 'BROWSER';
    // if (window.navigator.userAgent.indexOf('Chrome') !== -1) { currentBrowser = 'GoogleChrome'; }
    // else if (window.navigator.userAgent.indexOf('Firefox') !== -1) { currentBrowser = 'MozillaFirefox'; }
    // else if (window.navigator.userAgent.indexOf('MSIE') !== -1) { currentBrowser = 'InternetExplorer'; }
    // else if (window.navigator.userAgent.indexOf('Edge') !== -1) { currentBrowser = 'Edge'; }
    // else if (window.navigator.userAgent.indexOf('Safari') !== -1) { currentBrowser = 'Safari'; }
    // else if (window.navigator.userAgent.indexOf('Opera') !== -1) { currentBrowser = 'Opera'; }
    // else if (window.navigator.userAgent.indexOf('Opera') !== -1) { currentBrowser = 'YaBrowser'; }
    // else { console.log('Others'); }

    return currentBrowser;
}
export function getCountries(){
    const config = getAppCfg();
    var countriesList = [];
    var agreement_countries = config && config.contact && config.contact.agreement_countries ? config.contact.agreement_countries : null;
    if(agreement_countries){
        agreement_countries.forEach(c => {
        var findCountry = countries.filter(f => {
            return f.value == c.country
        })
        if(findCountry && findCountry.length > 0){
            countriesList.push(findCountry[0]);
        }
    });
    }
    return countriesList.sort(sortCountryByName);
}
function sortCountryByName(n1,n2){
    if(n1.label > n2.label)
        return 1;
    else if(n1.label < n2.label)
        return -1;
    else return 0;
}

export function getCountryDefault(agreement_countries){
    if(agreement_countries && agreement_countries.length > 0){
        var country = agreement_countries.filter(c => {
            return c.is_default
        })
        var countryDefault = null;
        if(country.length > 0){
            countryDefault = country[0];
        }else{
            countryDefault = agreement_countries[0];
        }
        var findCountryObj = countries.filter(f => {
            return f.value == countryDefault.country
        })
        if(findCountryObj.length > 0){
            return findCountryObj[0];
        }else{
            return null;
        }
    }
    return null;
}
export function getCountryDefaultByCode(country_code) {
    var findCountry = countries.filter(f => {
        return f.value == country_code
    })
    if(findCountry && findCountry.length > 0){
        return findCountry[0]
    }
    return null;
}
export function checkCountrySupport(country_code) {
    var isSupported = false;
    const config = getAppCfg();
    var agreement_countries = config && config.contact && config.contact.agreement_countries ? config.contact.agreement_countries : null;
    //console.log("AAAA agreement_countries:",agreement_countries);
    if (agreement_countries && agreement_countries.length > 0) {
        var country = agreement_countries.filter(c => {
            return c.country == country_code;
        })
        if (country && country.length > 0) {
            isSupported = true;
        }
    }
    return isSupported
}

export function getConditionContentByAllotment(allotment) {
    var conditionText = t('allotment_condition');
    var organisations = allotment.organisations;
    var products = allotment.products;
    var timings = allotment.timings;
    if (organisations.length == 0 && products.length == 0 && timings.length == 0) {
        conditionText += t('on') + t('any_day') + t('and') + t('any_time')
    } else {
        var productContent = getContentByProducts(products);
        if (productContent)
            conditionText = conditionText + productContent + " ";
        var dayContent = getContentByDays(timings);
        if (dayContent)
            conditionText = conditionText + dayContent + " ";
        var timeContent = getContentByTiming(timings);
        conditionText = conditionText + timeContent;
        var orgContent = getContentByOrganisations(organisations);
        if (orgContent)
            conditionText = conditionText + " " + orgContent;
    }
    return conditionText;
}

function getContentByProducts(products) {
    var productList = products.filter(function (product) {
        if (product.name) {
            return true; // skip
        }
        return false;
    }).map(function (product) { return product.name; });
    if (productList.length > 0) {
        productList = productList.join(", ");
        return t('on') + productList;
    }
    return ""
}

function getContentByDays(times) {
    times = times.sort(sortDay);
    var daysList = times.filter(function (time) {
        if (time.day) {
            return true;
        }
        return false;
    }).map(function (time) {
        if (time.day) {
            var days = createDayOfWeek();
            if (time.day == 1)
                return days[0];
            return days[time.day - 1];
        }
    });
    if (daysList && daysList.length > 0) {
        daysList = daysList.join(", ");
        return t('on') + daysList
    }
    else
        return ""
}

function getContentByTiming(times) {
    var timesList = times.filter(function (time) {
        if (time.start_time && time.end_time) {
            return true;
        }
        return false;
    })
    if (timesList && timesList.length > 0) {
        var time = timesList[0];
        return t('between') + time.start_time + "-" + time.end_time + " ";
    } else {
        return t('at') + t('any_time')
    }
}

function getContentByOrganisations(organisations) {
    var orgList = organisations.map(org => {
        if (org.name)
            return org.name;
    }).join(", ");
    if (orgList) {
        return t('at') + t('the_following_venues') + " " + orgList;
    }
    return ""
}

function sortDay(n1, n2) {
    if (n1.day > n2.day)
        return 1;
    else if (n1.day < n2.day)
        return -1;
    else return 0;
}

export function initOptionHeader(){
    return {
            'User-Agent': 'request',
            'Content-Type': 'application/json; charset=utf-8'
    }
}

export function sortCartByProductName(n1, n2) {
    if (n1.name > n2.name)
        return 1;
    else if (n1.name < n2.name)
        return -1;
    else return 0;
}

export function setPaymentRecuring(data) {
    data = JSON.stringify(data)
    localStorage.setItem(PAYMENT_RECURING, data);
}
export function getPaymentRecuring() {
    var config = localStorage.getItem(PAYMENT_RECURING);
    if (!config)
        return null;
    config = JSON.parse(config);
    return config
}

export async function checkAllowAddService() {
    let isAllowAddService = false;
    try {
        let result = await crmservices.contacts.getListContactServices({
            size: 100,
        });
        let services = result?.data?.content || [] ;
        if (services && services.length > 0) {
            let freeTVService = services.find(x => x.service?.product?.sku?.toUpperCase() == portal_config.add_on_free);
            if (freeTVService && freeTVService.service && freeTVService.service.id) {
                isAllowAddService = true;
            }
        }
    } catch (error) {
        console.log("AAAA checkAllowAddService error: ", error)
    }
    console.log("AAAA checkAllowAddService isAllowAddService: ", isAllowAddService)
    return isAllowAddService;
}

export function setPortalConfigV2(config) {
    // let order = config?.features?.contact?.order || null;
    localStorage.setItem('portal_config', JSON.stringify(config));
}

export function getPortalConfigV2() {
    let config = localStorage.getItem('portal_config');
    if (config) config = JSON.parse(config)
    else return null;
    return config
}